export const contractAction = {
  SET_CONTRACT_STATE: "SET_CONTRACT_STATE",
  FETCH_CONTRACT_LIST: "FETCH_CONTRACT_LIST",
  FETCH_ALL_CONTRACT: "FETCH_ALL_CONTRACT",
  SKIP_CONTRACT: "SKIP_CONTRACT",

  setContractState: (data) => ({
    type: contractAction.SET_CONTRACT_STATE,
    payload: data,
  }),

  fetchContractList: (url, postData, nextState) => ({
    type: contractAction.FETCH_CONTRACT_LIST,
    payload: { url: url, postData: postData, nextState: nextState },
  }),

  fetchALLContract: (url, postParameter, nextState) => ({
    type: contractAction.FETCH_ALL_CONTRACT,
    payload: {
      url,
      nextState,
      postParameter: {
        ...postParameter,
        ManagerName: postParameter.ManagerName || "",
        EmployeeName: postParameter.EmployeeName || "",
      },
    },
  }),

  skipContract: (orderNo) => ({
    type: contractAction.SKIP_CONTRACT,
    payload: {
      orderNo,
    },
  }),
}
